<div class="text-center">
  <img
    ngSrc="assets/shaparak.png"
    width="320"
    height="160"
    alt="saved successfully"
  />
</div>
<p class="text-center text-high-emphasis text-center">کارت شما با موفقیت ذخیره شد!</p>
<p class="text-medium-emphasis fs-14 fw-normal">
  برای انجام انتفال وجه از مبدا {{ card().bankName }}، لازم است یک‌بار کارتتان را در سیستم شاپرک وارد کنید.
</p>

<daily-bank-card-preview [config]="card()"></daily-bank-card-preview>

<div class="d-flex justify-content-space-between gap-small mt-mega">
  <common-ui-components-temp-ngx-button
    [style]="'tinted-on-elevated'"
    [size]="'medium'"
    size="medium"
  >
    بعدا انجام می‌دهم
  </common-ui-components-temp-ngx-button>
  <common-ui-components-temp-ngx-button
    (clickHandler)="submitToShaparak()"
    [size]="'medium'"
  >
    ثبت کارت در شاپرک
  </common-ui-components-temp-ngx-button>
</div>
